'use client';

/** PWA install banner disabled — renders nothing on all platforms. */
export function InstallAppBanner() {
  return null;
}
